import React from 'react'
import pilic from '../img/pilic.jpg'

const Coaches = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr />
                        <h2 className="intro-text text-center">Treneri</h2>
                        <hr />
                        <hr className="visible-xs" />
                        <div className="col-lg-4">
                            <img className="img-responsive" src={pilic} alt="" />
                        </div>
                        <div className="col-lg-8">
                            <p>Voditelj tenis kluba Vamos je Zlatan Bilić.</p>
                            <p>Igračko iskustvo : (nekoliko puta državni prvak BIH, top 5 igrač u juniorskoj dobi, sudionik natjecanja 3 Hrvatske lige)</p>
                            <ul>
                                <li>Diplomirao na Kineziološkom fakultetu 2014. godine, usmjerenje tenis.</li>
                                <li>Vanjski suradnik na Kineziološkom fakultetu od 2015. godine na kolegiju Tenis</li>
                                <li>B licenca Hrvatskog teniskog saveza</li>
                                <li>član Zbora trenera HTS-a</li>
                                <li>sudjelovao u provedbi kampova koje je organizirao Hrvatski teniski savez</li>
                                <li>višegodišnje iskustvo s radom najperspektivnijih mladjih i starijih juniora/ki</li>
                                <li>višegodišnje iskustvo s radom u tenis školi za predškolsku i školsku djecu</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Coaches



// WEBPACK FOOTER //
// ./src/components/Coaches.js